import type { WorkbookPanelName } from 'cadenza/workbook/workbook-panel/workbook-panel-utils';
import { togglePanelVisibility } from 'cadenza/workbook/workbook.state';

export const showPanel = (panelId: WorkbookPanelName, options?: { highlight?: boolean }) =>
  togglePanelVisibility(panelId, true, options);
export const hidePanel = (panelId: WorkbookPanelName) => togglePanelVisibility(panelId, false);
